export const TELEMETRY_OPT_OUT_STORAGE_KEY = 'patter.telemetry.optOut'

type TelemetryPreferenceStorage = Pick<Storage, 'getItem' | 'removeItem' | 'setItem'>

function getBrowserTelemetryStorage(): TelemetryPreferenceStorage | null {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    return window.localStorage
  } catch {
    return null
  }
}

export function isTelemetryOptedOut(
  storage: TelemetryPreferenceStorage | null = getBrowserTelemetryStorage(),
) {
  if (!storage) {
    return false
  }

  return storage.getItem(TELEMETRY_OPT_OUT_STORAGE_KEY) === '1'
}

export function setTelemetryOptOutPreference(
  optedOut: boolean,
  storage: TelemetryPreferenceStorage | null = getBrowserTelemetryStorage(),
) {
  if (!storage) {
    return
  }

  if (optedOut) {
    storage.setItem(TELEMETRY_OPT_OUT_STORAGE_KEY, '1')
    return
  }

  storage.removeItem(TELEMETRY_OPT_OUT_STORAGE_KEY)
}

